import React from 'react'

const getDataStyleClasses = (dataStyle) => {
  switch (dataStyle) {
    case 'success':
      return 'bg-green-600 text-white'
    case 'warning':
      return 'bg-yellow-500 text-white'
    case 'danger':
      return 'bg-red-600 text-white'
    case 'info':
      return 'bg-blue-600 text-white'
    default:
      return 'bg-gray-600 text-white'
  }
}

export default ({ label, data, dataStyle }) => (
  <div className="flex rounded-lg overflow-hidden shadow-sm w-full md:w-auto">
    <div className="bg-white text-gray-700 px-3 md:px-4 py-2 md:py-2.5 text-sm md:text-base font-medium border border-gray-200 flex-1 md:flex-initial">
      {label}
    </div>
    <div
      className={`px-4 md:px-5 py-2 md:py-2.5 text-base md:text-lg font-bold min-w-[3.5rem] md:min-w-[4rem] text-center ${getDataStyleClasses(dataStyle)}`}
    >
      {data !== undefined ? data : '-'}
    </div>
  </div>
)
